// extracted by mini-css-extract-plugin
export default {"FAQWrapper":"FAQs-module--FAQWrapper--xZBDg","Description":"FAQs-module--Description--tt6UC"};